import {
  WorkInjuryAcceptedCoverageType,
  WorkInjuryEmployerLiabilityBundle
} from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import {
  RequirementVersionScope,
  RequirementVersionTransitionStrategy
} from "@wingspanhq/payments/dist/interfaces";

import { FlowCreateNewVersionTransitionData } from "../../types";

export const DEFAULT_RENEWAL_DEADLINE_DAYS = 30;

export const DEFAULT_TRANSITION_DATA: FlowCreateNewVersionTransitionData = {
  renewalDeadlineDays: DEFAULT_RENEWAL_DEADLINE_DAYS,
  scope: RequirementVersionScope.All,
  transitionMethod: RequirementVersionTransitionStrategy.Renewal
};

export const WORKERS_COMP_BUNDLE_LABELS: Record<string, string> = {
  [WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred]:
    "$500k / $500k / $500k",
  [WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred]:
    "$100k / $500k / $100k",
  [WorkInjuryEmployerLiabilityBundle.OneMillionBundle]: "$1M / $1M / $1M"
};

export const COVERAGE_TYPE_LABELS: Record<string, string> = {
  [WorkInjuryAcceptedCoverageType.Either]:
    "Workers' Comp or Occupational Accident",
  [WorkInjuryAcceptedCoverageType.OccupationalAccident]:
    "Occupational Accident only",
  [WorkInjuryAcceptedCoverageType.WorkersCompensation]:
    "Workers' Compensation only"
};
